import React from 'react'
import { Mutation } from "react-apollo";
import Form from "../components/form";
import { ADD, GET } from "../../../queries/network";
import { ADD_EDIT_NETWORK_SITE } from "../../../queries/networkSite";

const Add = (props) => {
  return (
    <Mutation
      mutation={ADD}
      update={(store, { data: { createNetwork } }) => {
        const { networks } = store.readQuery({ query: GET });
        store.writeQuery({
          query: GET,
          data: { networks: networks.concat([createNetwork]) }
        });
      }}
      >
        {createNetwork => (
        <Mutation mutation={ADD_EDIT_NETWORK_SITE} update={(store, { data: { createNetwork } }) => {}}>
        {createNetworkSite=> (
            <Form query_f = {createNetwork} query_networkSite={createNetworkSite} {...props} />
        )}
        </Mutation>
        )}
    </Mutation>
  );
};

export default Add;